import React from 'react';

const QuoteImages = () => {
  return (
    <>
      <img src={'/-/media/Project/FAB2/shared/images/img_simpleQuote.svg'} />
      <img src={'/-/media/Project/FAB2/shared/images/img_simpleQuote.svg'} />
    </>
  );
};

export default QuoteImages;
